import type { MembershipsCreatorV2ApiClient } from '@fourthwall/services/dist/MembershipsCreatorV2ApiClient'

import type { FormValues } from '../../types'
import { getCommonFieldsPayload } from './getCommonFieldsPayload'

type Payload = Parameters<typeof MembershipsCreatorV2ApiClient.createLiveStreamPost>[0]

export const getCreateLiveStreamPostPayload = (values: FormValues): Payload => {
  const commonPayload = getCommonFieldsPayload(values)

  return {
    post: {
      title: commonPayload.attributes.core.title,
      description: commonPayload.attributes.core.description,
      startsAt: commonPayload.attributes.core.liveAt!,
      tags: commonPayload.attributes.core.tags,
      series: values.videoSeries,
    },
    access: commonPayload.access,
    notifications: commonPayload.notifications,
    liveStreamResourceId: values.liveStreamResourceId!,
    imageResourceId: undefined,
  }
}
